export const rankSearchResults = (premiumProducts = [], organicProducts = [], cap = 4) => {
  const ranked = []
  const seen = new Set()
  const append = product => {
    const id = product?._id || product?.id
    if (!id || seen.has(String(id))) return
    seen.add(String(id))
    ranked.push(product)
  }

  premiumProducts
    .slice(0, Math.max(0, cap))
    .map(product => ({ ...product, searchShowcasePromoted: true }))
    .forEach(append)
  organicProducts.forEach(append)
  return ranked
}

export const mergeUniqueProducts = (...groups) => {
  const merged = []
  const seen = new Set()
  groups.flat().forEach(product => {
    const id = product?._id || product?.id
    if (!id || seen.has(String(id))) return
    seen.add(String(id))
    merged.push(product)
  })
  return merged
}

export const isLiveSearchQuery = value => String(value || '').trim().length >= 2

export const getSearchQuery = searchParams => (
  searchParams.get('value') || searchParams.get('keyword') || searchParams.get('q') || searchParams.get('search') || ''
).trim()
